<template>
    <div :id="this.$route.name">
        <card back>
            <template v-slot:header>
                <h4 class="d-inline">{{ title }}</h4>
                <hr />
            </template>
            <template v-slot:content>
                <form autocomplete="off">
                    <tab :tab="Tablist">
                        <template v-slot:content0>
                            <div class="row">
                                <div class="col-md-4 col-12">
                                    <small id="LblGetWorkShopCombo"> کارگاه</small>
                                    <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetWorkShopCombo"
                                        :defaultvalue="DataAxios.TblWorkshopId" :rownumintable="3"
                                        :action="'TblSalaryCombo/GetWorkShopCombo'" :method="'POST'"
                                        :idinput="'GetWorkShopCombo'" :keyItem="'GetWorkShopCombo'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblName">نام </small>
                                    <input type="text" class="form-control InputText required" v-model="DataAxios.Name" />
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblFamily">نام خانوادگی </small>
                                    <input type="text" class="form-control InputText required" v-model="DataAxios.Family" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-12">
                                    <small id="LblNationalCode">کد ملی</small>
                                    <input type="text" dir="ltr" class="form-control InputText required-CodeMeli required"
                                        v-mask="'##########'" maxlength="10" @keypress="$ValidNumber($event, 10)"
                                        @input="$CheckupLengthCodeMeli($event)" v-model="DataAxios.NationalCode" />
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblIdCardNumber">شماره شناسنامه </small>
                                    <input type="number" dir="ltr" class="form-control InputText required"
                                        v-model="DataAxios.IdCardNumber" />
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblFatherNmae">نام پدر</small>
                                    <input type="text" dir="ltr" class="form-control InputText required"
                                        v-model="DataAxios.FatherNmae" />
                                </div>
                            </div>
                            <div class="row  mt-4">
                                <div class="col-md-4 col-12">
                                    <small id="LblPersonnelCode">کد پرسنلی</small>
                                    <input type="number" dir="ltr" class="form-control InputText required"
                                        v-model="DataAxios.PersonnelCode" />
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblInsuranceNumber"> شماره بیمه </small>
                                    <input type="number" dir="ltr" class="form-control InputText required"
                                        v-model="DataAxios.InsuranceNumber" />
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LbInsuranceHistoryMonth">سابقه به ماه</small>
                                    <input type="number" dir="ltr" class="form-control InputText required"
                                        v-model="DataAxios.InsuranceHistoryMonth" />
                                </div>
                            </div>
                            <div class="row  mt-4">
                                <div class="col-md-4 col-12">
                                    <small id="LblBirthDate"> تاریخ تولد</small>
                                    <date-picker color="dimgray" input-class="required form-control required"
                                        v-model="DataAxios.BirthDate" clearable :editable="true"
                                        placeholder="تاریخ تولد"></date-picker>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblPlaceOfBirthGrp200"> محل تولد</small>
                                    <SearchableCombo :edit="false" :grp="200" :code="null" @ResultCombo="GetResultCity"
                                        :rownumintable="3" :defaultvalue="DataAxios.PlaceOfBirthGrp200"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'" :idinput="'City'"
                                        :keyItem="'City'" :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblMilitaryStatusGrp14"> خدمت سربازی </small>
                                    <SearchableCombo :edit="false" :grp="14" :code="null"
                                        @ResultCombo="GetMilitaryStatusGrp14" :rownumintable="3"
                                        :defaultvalue="DataAxios.MilitaryStatusGrp14"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'MilitaryStatusGrp14'" :keyItem="'MilitaryStatusGrp14'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                            </div>
                            <div class="row  mt-2">
                                <div class="col-md-4 col-12">
                                    <small id="LblIdCardIssueDate">تاریخ صدور شناسنامه</small>
                                    <date-picker color="dimgray" input-class="required form-control required"
                                        v-model="DataAxios.IdCardIssueDate" clearable :editable="true"
                                        placeholder="تاریخ صدور شناسنامه"></date-picker>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblIdCardIssuePlaceGrp200">محل صدور شناسنامه</small>
                                    <SearchableCombo :edit="false" :grp="200" :code="null"
                                        @ResultCombo="GetIdCardIssuePlaceGrp200" :rownumintable="3"
                                        :defaultvalue="DataAxios.IdCardIssuePlaceGrp200"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'IdCardIssuePlaceGrp200'" :keyItem="'IdCardIssuePlaceGrp200'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblPersonnelCode">بخش محل صدور</small>
                                    <input type="text" class="form-control InputText "
                                        v-model="DataAxios.IssuingDepartment" />
                                </div>
                            </div>
                            <div class="row  mt-2">
                                <div class="col-md-4 col-12">
                                    <small id="LblMaritalStatusGrp15"> وضعیت تاهل </small>
                                    <SearchableCombo :edit="false" :grp="15" :code="null"
                                        @ResultCombo="GetMaritalStatusGrp15" :rownumintable="3"
                                        :defaultvalue="DataAxios.MaritalStatusGrp15" :action="'TblSalaryCombo/GetComboById'"
                                        :method="'POST'" :idinput="'MaritalStatusGrp15'" :keyItem="'MaritalStatusGrp15'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblChildrenCount"> تعداد فرزندان </small>
                                    <input type="number" dir="ltr" class="form-control InputText "
                                        v-model="DataAxios.ChildrenCount" />
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblGenderGrp13"> جنسیت </small>
                                    <SearchableCombo :edit="false" :grp="13" :code="null" @ResultCombo="GetGenderGrp13"
                                        :rownumintable="3" :defaultvalue="DataAxios.GenderGrp13"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'" :idinput="'GenderGrp13'"
                                        :keyItem="'GenderGrp13'" :ClassProps="'required'"> </SearchableCombo>
                                </div>
                            </div>
                            <div class="row  mt-2">
                                <div class="col-md-12 col-12">
                                    <small id="LblAddress"> آدرس </small>
                                    <input type="text" class="form-control InputText " v-model="DataAxios.Address" />
                                </div>
                            </div>
                        </template>
                        <template v-slot:content1>
                            <div class="row">
                                <div class="col-md-4 col-12">
                                    <small id="LblTypeOfInsuranceGrp17"> نوع بیمه </small>
                                    <SearchableCombo :edit="false" :code="null" :grp="17"
                                        @ResultCombo="GetTypeOfInsuranceGrp17"
                                        :defaultvalue="DataAxios.TypeOfInsuranceGrp17" :rownumintable="3"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'TypeOfInsuranceGrp17'" :keyItem="'TypeOfInsuranceGrp17'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblInsuranceDescription">نام یا شرح بیمه </small>
                                    <input type="text" class="form-control InputText "
                                        v-model="DataAxios.InsuranceDescription" />
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblInsuranceDescription">سمت یا شغل (بیمه) </small>
                                    <SearchableCombo :edit="false" :grp="202" :code="null"
                                        @ResultCombo="GetInsurancePositionOrJobGrp202" :rownumintable="3"
                                        :defaultvalue="DataAxios.InsurancePositionOrJobGrp202"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'MilitaryStatusGrp14'" :keyItem="'MilitaryStatusGrp14'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <small id="LblDegreeOfEducationGrp16"> مدرک تحصیلی </small>
                                    <SearchableCombo :edit="false" :code="null" :grp="16"
                                        @ResultCombo="GetDegreeOfEducationGrp16"
                                        :defaultvalue="DataAxios.DegreeOfEducationGrp16" :rownumintable="3"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'DegreeOfEducationGrp16'" :keyItem="'DegreeOfEducationGrp16'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-6 col-12">
                                    <small id="LblFieldOfStudyGrp"> رشته تحصیلی </small>
                                    <input type="text" class="form-control InputText " v-model="DataAxios.FieldOfStudy" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <small id="LblContractStartDate">تاریخ شروع قرارداد</small>
                                    <date-picker color="dimgray" input-class="required form-control required"
                                        v-model="DataAxios.ContractStartDate" clearable :editable="true"
                                        placeholder="تاریخ شروع قرارداد"></date-picker>
                                </div>
                                <div class="col-md-6 col-12">
                                    <small id="LblContractEndDate">تاریخ پایان قرارداد</small>
                                    <date-picker color="dimgray" input-class="form-control"
                                        v-model="DataAxios.ContractEndDate" clearable :editable="true"
                                        placeholder="تاریخ پایان قرارداد"></date-picker>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4 col-12">
                                    <small id="LblTypeOfContractGrp19"> نوع قرارداد </small>
                                    <SearchableCombo :edit="false" :code="null" :grp="19"
                                        @ResultCombo="GetTypeOfContractGrp19" :defaultvalue="DataAxios.TypeOfContractGrp19"
                                        :rownumintable="3" :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'TypeOfContractGrp19'" :keyItem="'TypeOfContractGrp19'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblTypeOfEmploymentGrp18"> نوع استخدام </small>
                                    <SearchableCombo :edit="false" :code="null" :grp="18"
                                        @ResultCombo="GetTypeOfEmploymentGrp18"
                                        :defaultvalue="DataAxios.TypeOfEmploymentGrp18" :rownumintable="3"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'TypeOfEmploymentGrp18'" :keyItem="'TypeOfEmploymentGrp18'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblServiceLocationStatusGrp23"> وضعیت محل خدمت </small>
                                    <SearchableCombo :edit="false" :code="null" :grp="23"
                                        @ResultCombo="GetServiceLocationStatusGrp23"
                                        :defaultvalue="DataAxios.ServiceLocationStatusGrp23" :rownumintable="3"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'ServiceLocationStatusGrp23'" :keyItem="'ServiceLocationStatusGrp23'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4 col-12">
                                    <small id="LblJobGroupGrp22"> رسته شغلی </small>
                                    <SearchableCombo :edit="false" :code="null" :grp="22" @ResultCombo="GetJobGroupGrp22"
                                        :defaultvalue="DataAxios.JobGroupGrp22" :rownumintable="3"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'" :idinput="'JobGroupGrp22'"
                                        :keyItem="'JobGroupGrp22'" :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblEmployeeStatusGrp20"> وضعیت کارمند </small>
                                    <SearchableCombo :edit="false" :code="null" :grp="20"
                                        @ResultCombo="GetEmployeeStatusGrp20" :defaultvalue="DataAxios.EmployeeStatusGrp20"
                                        :rownumintable="3" :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'EmployeeStatusGrp20'" :keyItem="'EmployeeStatusGrp20'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblServiceLocation"> محل خدمت </small>
                                    <input type="text" class="form-control InputText "
                                        v-model="DataAxios.ServiceLocation" />
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4 col-12">
                                    <small id="LblBankGrp201">نام بانک</small>
                                    <SearchableCombo :edit="false" :code="null" :grp="201" @ResultCombo="GetBankGrp201"
                                        :defaultvalue="DataAxios.BankGrp201" :rownumintable="3"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'" :idinput="'BankGrp201'"
                                        :keyItem="'BankGrp201'"> </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblSalaryAccountNumber"> شماره حساب حقوق </small>
                                    <input type="number" dir="ltr" class="form-control InputText "
                                        v-model="DataAxios.SalaryAccountNumber" />
                                </div>
                                <div class="col-md-4 col-12">
                                    <small id="LblBankGrp201">ملیت</small>
                                    <SearchableCombo :edit="false" :code="null" :grp="12" @ResultCombo="GetNationalityGrp12"
                                        :defaultvalue="DataAxios.NationalityGrp12" :rownumintable="3"
                                        :action="'TblSalaryCombo/GetComboById'" :method="'POST'"
                                        :idinput="'NationalityGrp12'" :keyItem="'NationalityGrp12'"
                                        :ClassProps="'required'"> </SearchableCombo>
                                </div>
                            </div>
                        </template>
                        <template v-slot:content2>
                            <div class="row">
                                <div class="col-md-4 col-12">
                                    <div class="mt-3">
                                        <small id="LblPersonnelStatus">وضعیت پرسنل </small>
                                        <span class="form-control p-1">
                                            <div class="custom-control custom-switch text-center">
                                                <input type="checkbox" checked class="custom-control-input InputText"
                                                    id="PersonnelStatus" v-model="DataAxios.PersonnelStatus" />
                                                <label class="custom-control-label" for="PersonnelStatus"> فعال/غیرفعال
                                                </label>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-4 col-12 mt-3">
                                    <small id="LblTblUserId"> انتخاب کاربـر CRM </small>
                                    <SearchableCombo :key="keyUserIdTaskCombo" :edit="false" :grp="0" :code="null"
                                        @ResultCombo="GetResulUserId" :rownumintable="3" :defaultvalue="DataAxios.TblUserId"
                                        :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserId'"
                                        :keyItem="'UserId'">
                                    </SearchableCombo>
                                </div>
                                <div class="col-md-4 col-12 mt-3">
                                    <small id="LblTblSarfaslId">سرفصل حسابداری</small>
                                    <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetTblSarfaslId"
                                        :defaultvalue="DataAxios.TblSarfaslId" :rownumintable="3"
                                        :action="'SarfaslSalary/GetComboByCodeMeli/' + DataAxios.NationalCode" :method="'GET'" :idinput="'KasreSalary'"
                                        :keyItem="'TblSarfaslId'"> </SearchableCombo>
                                </div>
                            </div>
                        </template>
                    </tab>
                </form>
                <hr />
                <button v-if="$route.params.Status == 'Add'" class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت
                    اطلاعات</button>
                <button v-if="$route.params.Status == 'Edit'" class="btn btn-success mr-5"
                    @click.prevent="SaveEditDeta()">ثبت تغییرات</button>
                <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel()">انصراف</button>
            </template>
        </card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Tab from '@/components/Tab/Tab.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
    components: {
        Card, Tab, SearchableCombo, datePicker: VuePersianDatetimePicker
    },
    data() {
        return {
            DataAxios: {},
            title: '',
            DataAxiosPost: {
                ArryfildValue: {},
                Method: 'post',
                Action: '',
                Token: this.$session.get('Token'),
                From: 'Body',
            },
            DataAxiosUpdate: {
                ArryfildValue: {},
                Method: 'put',
                Action: '',
                Token: this.$session.get('Token'),
                From: 'Body',
            },
            Tablist: [{ header: 'اطلاعات اصلی' }, { header: 'اطلاعات بیمه و قرارداد ' }, { header: 'سایر اطلاعات' }],
            keyUserIdTaskCombo: 0
        }
    },
    created() {
        if (this.$route.params.Status == 'Add') {
            this.title = 'اضافه کردن پرسنل'
        } else {
            this.title = 'ویـرایـش پرسنل'
        }
        this.DataAxios.PersonnelStatus = true
    },
    mounted() {
        if (this.$route.params.Status == 'Add') {
            this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
            this.keyUserIdTaskCombo++
        }
        if (this.$route.params.Status == 'Edit') {
            this.DataAxios = this.$route.params.DataRow
            this.DataAxios.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
            this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)
            this.keyUserIdTaskCombo++
        }
    },
    methods: {
        Cancel() {
            this.$router.go(-1)
        },
        SaveDeta() {
            if (this.$ValidForm(this.$route.name)) {
                this.DataAxiosPost.Action = 'Personnel'
                this.DataAxiosPost.ArryfildValue = this.DataAxios
                this.$PostData(this.DataAxiosPost).then((data) => {
                    if (data.IsSuccess == true) {
                        this.$toasted.success('پرسنل با موفقیت ایجاد شد', {
                            action: {
                                text: 'بستن',
                                onClick: (e, toastObject) => {
                                    toastObject.goAway(0)
                                },
                            },
                        })
                        this.Cancel()
                    }
                    else {
                        if (data.IsSuccess == false) {
                            this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                        }
                    }
                }).catch((err) => {
                    console.error(err)
                    this.$mySweetDefaultTost('', 'خطای سمت سرور', 'error', 3000)
                })
            }
        },
        SaveEditDeta() {
            this.DataAxiosUpdate.Action = 'Personnel'
            this.DataAxiosUpdate.ArryfildValue = this.DataAxios
            this.$PutData_Body(this.DataAxiosUpdate).then((data) => {
                if (data.IsSuccess == true) {
                    this.$SetLog(this.DataAxios, 0)
                    this.$toasted.success('اطلاعات پرسنل با موفقیت تغییر یافت', {
                        action: {
                            text: 'بستن',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0)
                            },
                        },
                    })
                    this.Cancel()
                } else {
                    if (data.IsSuccess == false) {
                        this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                    }
                }
            }).catch((err) => {
                console.error(err)
                this.$mySweetDefaultTost('', 'خطای سمت سرور', 'error', 3000)
            })
        },
        GetWorkShopCombo(data) {
            if (data.id != null) {
                this.DataAxios.TblWorkshopId = data.id
            }
        },
        GetResultCity(data) {
            if (data.id != null) {
                this.DataAxios.PlaceOfBirthGrp200 = data.id
            }
        },
        GetMilitaryStatusGrp14(data) {
            if (data.id != null) {
                this.DataAxios.MilitaryStatusGrp14 = data.id
            }
        },
        GetIdCardIssuePlaceGrp200(data) {
            if (data.id != null) {
                this.DataAxios.IdCardIssuePlaceGrp200 = data.id
            }
        },
        GetMaritalStatusGrp15(data) {
            if (data.id != null) {
                this.DataAxios.MaritalStatusGrp15 = data.id
            }
        },
        GetGenderGrp13(data) {
            if (data.id != null) {
                this.DataAxios.GenderGrp13 = data.id
            }
        },
        GetTypeOfInsuranceGrp17(data) {
            if (data.id != null) {
                this.DataAxios.TypeOfInsuranceGrp17 = data.id
            }
        },
        GetInsurancePositionOrJobGrp202(data) {
            if (data.id != null) {
                this.DataAxios.InsurancePositionOrJobGrp202 = data.id
            }
        },
        GetTaxPositionOrJobGrp202(data) {
            if (data.id != null) {
                this.DataAxios.TaxPositionOrJobGrp202 = data.id
            }
        },
        GetDegreeOfEducationGrp16(data) {
            if (data.id != null) {
                this.DataAxios.DegreeOfEducationGrp16 = data.id
            }
        },
        GetBankGrp201(data) {
            if (data.id != null) {
                this.DataAxios.BankGrp201 = data.id
            }
        },
        GetNationalityGrp12(data) {
            if (data.id != null) {
                this.DataAxios.NationalityGrp12 = data.id
            }
        },
        GetTypeOfContractGrp19(data) {
            if (data.id != null) {
                this.DataAxios.TypeOfContractGrp19 = data.id
            }
        },
        GetTypeOfEmploymentGrp18(data) {
            if (data.id != null) {
                this.DataAxios.TypeOfEmploymentGrp18 = data.id
            }
        },
        GetServiceLocationStatusGrp23(data) {
            if (data.id != null) {
                this.DataAxios.ServiceLocationStatusGrp23 = data.id
            }
        },
        GetJobGroupGrp22(data) {
            if (data.id != null) {
                this.DataAxios.JobGroupGrp22 = data.id
            }
        },
        GetEmployeeStatusGrp20(data) {
            if (data.id != null) {
                this.DataAxios.EmployeeStatusGrp20 = data.id
            }
        },
        GetResulUserId(data) {
            if (data.id != null) {
                this.DataAxios.TblUserId = data.id
            }
        },
        GetTblSarfaslId(data) {
            if (data.id != null) {
                this.DataAxios.TblSarfaslId = data.id
            }
        },
    }
}
</script>
<style scoped></style>